import { useGlobalConfig }      from "context/GlobalContext";
import { useEffect }            from "react";
import { useNavigate, useSearchParams } from "react-router";

export const RootComponent = () => {

  const navigate = useNavigate()
  const { rc } = useGlobalConfig()
  const [searchParams] = useSearchParams()

  useEffect(() => {

    // Password-reset emails link to `<frontend-url>?code=<token>` which lands on
    // root. Forward to the (public) reset page before the auth guard can bounce
    // an unauthenticated user to login and drop the code.
    const code = searchParams.get('code')
    if (code) {
      navigate(`/auth/reset-password?code=${encodeURIComponent(code)}`, { replace: true })
      return
    }

    // Auth guard will automatically redirect to login if no session is found
    rc.uiRouter.navigateToHome(navigate)
  })

  return (
    <></>
  )

}